var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440.29 318.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c2968b;}.cls-2{fill:#f6bdac;}.cls-3{fill:#daa79d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_copy",
    "data-name": "Layer 2 copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367,229.76H282.61a9,9,0,0,1,0-17.92H342a21.65,21.65,0,0,0,21.62-21.62v-9.34A21.65,21.65,0,0,0,342,159.26H300.47a60.26,60.26,0,0,0-53.61-87.11,57.06,57.06,0,0,0-78.77-50,74.88,74.88,0,0,0-128,52.77c0,.24,0,.48,0,.73A60.31,60.31,0,0,0,60.31,192.76H65A21.66,21.66,0,0,0,86.5,211.84H140a9,9,0,0,1,0,17.92h-4.37A21.64,21.64,0,0,0,114,251.38v9.33a21.64,21.64,0,0,0,21.61,21.62H225a9,9,0,0,1,9,9v5.1A21.65,21.65,0,0,0,255.56,318h62a21.65,21.65,0,0,0,21.62-21.62v-5.1a9,9,0,0,1,9-9H367a21.65,21.65,0,0,0,21.62-21.62v-9.33A21.65,21.65,0,0,0,367,229.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.66,132.45a47.64,47.64,0,0,1,35.56-46.1L53.34,85l-.4-5.27c-.15-1.85-.21-3.39-.21-4.84A62.23,62.23,0,0,1,161.82,34l3.27,3.74,4.4-2.28a43.9,43.9,0,0,1,20.35-4.94A44.48,44.48,0,0,1,234.27,74.9c0,.92,0,1.92-.13,3.13l-.47,6.77h12.81a47.59,47.59,0,0,1,39.34,74.46H86.5A21.64,21.64,0,0,0,64.9,180.1H60.31A47.7,47.7,0,0,1,12.66,132.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M376,260.71a9,9,0,0,1-9,9H348.16a21.64,21.64,0,0,0-21.62,21.61v5.1a9,9,0,0,1-9,9h-62a9,9,0,0,1-9-9v-5.1A21.63,21.63,0,0,0,225,269.68H135.59a9,9,0,0,1-9-9v-9.33a9,9,0,0,1,9-9H140a21.62,21.62,0,0,0,0-43.24H86.5a9,9,0,0,1-9-9v-9.34a9,9,0,0,1,9-9H342a9,9,0,0,1,9,9v9.34a9,9,0,0,1-9,9H282.61a21.62,21.62,0,0,0,0,43.24H367a9,9,0,0,1,9,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M211.15,308.37a6.5,6.5,0,0,1-6.5,6.5H144.2a6.5,6.5,0,0,1,0-13h60.45A6.5,6.5,0,0,1,211.15,308.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.5,236.29a6.5,6.5,0,0,1-6.5,6.5H27.44a6.5,6.5,0,0,1,0-13H91A6.5,6.5,0,0,1,97.5,236.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M402.33,129.76a6.5,6.5,0,0,1-6.5,6.5H332.27a6.5,6.5,0,0,1,0-13h63.56A6.5,6.5,0,0,1,402.33,129.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M433.79,172.09H397.53a6.5,6.5,0,0,1,0-13h36.26a6.5,6.5,0,0,1,0,13Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFog);
export default __webpack_public_path__ + "static/media/fog.90103b3e5c44229d209db4ec2e573e15.svg";
export { ForwardRef as ReactComponent };